








































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { default as Ytv } from "./Youtube/YoutubeVideo.vue";

@Component({
	components: {
		Ytv
	}
})
export default class Archive extends Vue {}
